import React from 'react';
import {connect} from 'react-redux';
import {Dispatch} from '@Redux/type';
import {AppState} from '@Redux/store';
// @ts-ignore
import bt_new_army_list from '@Images/en/bt_new_army_list.png';
import { container } from '@Container';
import { BookAction } from '@Redux/actions';
import { TYPES } from '@Types';
import { FormattedMessage } from 'react-intl';
import { defaultMessages } from '@I18n/default';

const BooksActionComponent: React.FC<Props> = ({create}) => {
  return (
    <section className="mt-2">
      <div className="row justify-content-center">
        <div className="col-6 col-sm-6 col-md-3 col-lg-3 col-xl-2 army_list_row">
          <a href="#" onClick={(e) => create(e)}>
            <img src={`${process.env.CDN ?? ''}${bt_new_army_list}`} className="img-fluid w-100"
                 alt={'publication.books.index.add'}/>
            <h4 className="boxtitre"><FormattedMessage {...defaultMessages.publicationBooksIndexAdd} /></h4>
          </a>
        </div>
      </div>
    </section>
  );
};

const mapStateToProps = (state: AppState) => ({
})

const mapDispatchToProps = (dispatch: Dispatch) => {
  const action = container.get<BookAction>(TYPES.Actions.Publication.BookAction)
  return {
    create: (e: any) => {
      e.preventDefault();
      dispatch(action.requestCreationBook())
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(BooksActionComponent);

type Props = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>
